export default __webpack_public_path__ + "static/media/indentApprove.d0f311d6.svg";